import { get } from "lodash";
import log from "loglevel";
import * as t from "types";

export const getConfigReducerResponse = (
  state: any,
  responseType: string
): t.Config => {
  log.info("Getting Config from Store...");
  const value = get(state, `config.response.${responseType}`);
  return value;
};

export const getConfigsReducerResponse = (
  state: any,
  responseType: string
): t.Config[] => {
  log.info("Getting All Configs from Store...");
  const value = get(state, `configs.response.${responseType}`);
  return value;
};

export const getConfigDefaultReducerResponse = (
  state: any,
  responseType: string
): t.ConfigDefault => {
  log.info("Getting Default Config from Store...");
  const value = get(state, `configDefault.response.${responseType}`);
  return value;
};
